import { Back } from './store/actions/router.action';
import { isPlatformServer } from '@angular/common';
import { Component, InjectionToken, PLATFORM_ID, inject } from '@angular/core';
import { RESPONSE } from '../express.tokens';
import { Router, RouterLink } from '@angular/router';
import { Response } from 'express';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { IconModule } from '@teamfoster/sdk/icon';
import { SetMenuTheme } from './store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-404',
  imports: [FromDictionaryPipe, RouterLink, IconModule],
  styles: [
    `
      :host {
        overflow: hidden;
        height: 100vh;
        align-items: center;
        justify-content: center;
      }
      .status-code {
        position: absolute;
        top: 45%;
        z-index: 0;
        color: var(--bs-light);
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 40vw;
        //text-align: center;
        line-height: 0.2;
        opacity: 0.1;
        //opacity: 0.5;
        font-weight: 700;
        text-transform: uppercase;
        text-wrap: nowrap;
      }
      .error-404 {
        background-color: var(--bs-primary);
      }
    `,
  ],
  template: `
    <article class="error-404 section-inset-y">
      <div class="container pt-topbar">
        <h1 class="text-max-width-md display-3 text-light" style="line-height:1; z-index:1; position:relative;">
          {{ ('error-404-title' | fromDictionary: false) || 'Sorry, we konden de pagina niet vinden.' }}
        </h1>
        <div class="error-404__content  mt-4">
          <a [routerLink]="'/'" class="button button--secondary z-3">
            <fstr-icon anchor="line-icon-arrow-left"></fstr-icon>
            <span>Terug naar home</span>
          </a>
        </div>

        <h2 class="status-code">{{ code }}</h2>
      </div>
    </article>
  `,
})
export class NotFoundComponent {
  private platformId = inject<InjectionToken<Object>>(PLATFORM_ID);
  private response = inject<Response>(RESPONSE, { optional: true })!;
  private router = inject(Router);
  private store = inject(Store);

  code = 404;

  constructor() {
    const statusCodeFromUrl = parseInt(this.router.url.replace(/\//g, ''));
    this.code = statusCodeFromUrl ? statusCodeFromUrl : 404;
    this.store.dispatch(SetMenuTheme('light'));
  }

  ngOnInit(): void {
    if (isPlatformServer(this.platformId)) {
      if (this.response) {
        this.response.status(this.code);
      }
    }
  }
}
